{{#if values}}
	<div class="config-container">
		<h4>{{TR "4-Punkte-Kennlinie"}}</h4>
		<table class="graph-values">
			<tr>
				<th></th>
				<th>P1</th>
				<th>P2</th>
				<th>P3</th>
				<th>P4</th>
			</tr>
			{{#each values}}
			<tr>
				<td class="table-column-heading">{{name}}</td>
				{{#each values}}
					<td>{{SHIFT_DECIMAL 1 val}} °C</td>
				{{/each}}
			</tr>
			{{/each}}
		</table>
	</div>
{{else}}
	<div class="config-container">
		<h4>{{TR "Steigungskennlinie"}}</h4>
		<table class="graph-values">
			<tr>
				<th></th>
				{{#each parameter.title}}
				<th class="table-column-heading">{{this}}</th>
				{{/each}}
			</tr>
			<tr>
				<td class="table-column-heading">{{TR "Steigung"}}</td>
				{{#each parameter.gradient}}
				<td>{{SHIFT_DECIMAL 1 val}}</td>
				{{/each}}
			</tr>
			<tr>
				<td class="table-column-heading">{{TR "Niveau"}}</td>
				{{#each parameter.level}}
				<td>{{SHIFT_DECIMAL 1 val}} °C</td>
				{{/each}}
			</tr>
			<tr>
				<td class="table-column-heading">{{TR "Tag Sollwert"}}</td>
				<td>{{SHIFT_DECIMAL 1 parameter.setPointDay.val}} °C</td>
				<td>--</td>
			</tr>
			<tr>
				<td class="table-column-heading">{{TR "Nacht Sollwert"}}</td>
				<td>{{SHIFT_DECIMAL 1 parameter.setPointNight.val}} °C</td>
				<td>--</td>
			</tr>
		</table>
	</div>
{{/if}}
<div class="limit-container">
	<h4>{{TR "Begrenzungen"}}</h4>
	<table class="graph-values">
		<tr>
			<th></th>
			<th class="table-column-heading">{{TR "Min"}}/{{TR "Fußpunkt"}}</th>
			<th class="table-column-heading">{{TR "Max"}}</th>
		</tr>
		<tr>
			<td class="table-column-heading">{{TR "Vorlauftemperatur"}}</td>
			{{#each limits.flow}}
			<td>{{SHIFT_DECIMAL 1 val}} °C</td>
			{{/each}}
		</tr>
		<tr>
			<td class="table-column-heading">{{TR "Rücklauftemperatur"}}</td>
			{{#each limits.backflow}}
			<td>{{SHIFT_DECIMAL 1 val}} °C</td>
			{{/each}}
		</tr>
	</table>
</div>
<div class="type-select-container">
	<b>{{TR "Hinweis"}}:</b> <p>{{TR "Begrenzungsfaktoren können zu Abweichungen bei den eingestellten Parametern führen."}}</p>
</div>
